import { CommunityResource } from './types';

export const communityResources: CommunityResource[] = [
  {
    name: "Hemiplegic Migraine Support: Almost Anything Goes",
    type: "facebook",
    url: "https://www.facebook.com/groups/181257286113225",
    members: "~2,400 members",
    description: "Support group for those diagnosed with Hemiplegic Migraine and their families."
  },
  {
    name: "Hemiplegic Migraine International",
    type: "facebook",
    url: "https://www.facebook.com/groups/hemiplegicmigraineinternational/",
    members: "~1,300 members",
    description: "Private support group for sufferers and carers to share experiences."
  },
  {
    name: "r/migraine",
    type: "reddit",
    url: "https://www.reddit.com/r/migraine/",
    members: "~80,000 members",
    description: "Reddit community with discussions on all migraine types including hemiplegic."
  },
  {
    name: "HM Teens & Young Adults",
    type: "facebook",
    url: "https://www.facebook.com/groups/hmteensyoungadults/",
    members: "~500 members",
    description: "Support group specifically for younger people dealing with hemiplegic migraines."
  },
  {
    name: "American Migraine Foundation Community",
    type: "website",
    url: "https://americanmigrainefoundation.org",
    members: "National organization",
    description: "Resources, doctor finder, and support for all migraine disorders."
  }
];